import { useContext } from 'react';
import { layoutContext } from '../FlashSustainabilityCalculator';
import './AssumptionsTable.scss';
import {
  Table,
  TableRow,
  TableBody,
  TableCell,
  Tooltip,
  Select,
  SelectItem,
} from 'carbon-components-react';

export interface assumptionsTableProps {
  contents: {
    assumptionsTitle: JSX.Element;
    carbonIntensityMetric: JSX.Element;
    countryData: {
      code: string;
      name: JSX.Element;
      exchangeRate: number;
      currencySymbol: string;
      electricity: number;
      carbonFactor: number;
    }[];
    evaluatedVariables: {
      icon: JSX.Element;
      label: JSX.Element;
      tooltip: JSX.Element;
    }[];
    footnote: JSX.Element;
  };
}

const AssumptionsTable = (assumptionsTableProps: assumptionsTableProps) => {
  const { contents } = assumptionsTableProps;
  const { currentCountry, setCurrentCountry } = useContext(layoutContext);

  let electricityConverted: number;

  if (currentCountry) {
    /* Then calculate the converted electricity value */
    electricityConverted =
      currentCountry?.electricity * currentCountry?.exchangeRate;
  }

  const handleCountryChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    /* Store country code (not translatable) received from the Select component */
    const selectedCountry = event.target.value;

    contents.countryData.filter((country) => {
      if (country.code === selectedCountry) {
        if (setCurrentCountry) {
          setCurrentCountry(country);
        }
      }
    });
  };

  return (
    <div className="assumptions-table-wrapper">
      <h4 className="title">{contents.assumptionsTitle}</h4>
      <Table style={{ overflow: 'hidden' }}>
        <TableBody>
          {contents.evaluatedVariables.map(
            (
              el: {
                icon: JSX.Element;
                label: JSX.Element;
                tooltip: JSX.Element;
              },
              i: number,
            ) => {
              return (
                <TableRow>
                  <TableCell>{el.icon}</TableCell>
                  <TableCell>{el.label}</TableCell>
                  <TableCell>
                    {i === 0 ? (
                      <Select
                        id="country"
                        className="spacer"
                        labelText=""
                        defaultValue={currentCountry?.code}
                        onChange={handleCountryChange}
                      >
                        {contents.countryData.map(
                          (
                            country: {
                              code: string;
                              name: JSX.Element;
                            },
                            index: number,
                          ) => (
                            <SelectItem
                              key={index}
                              value={country.code}
                              text={country.name.props.defaultMessage}
                            />
                          ),
                        )}
                      </Select>
                    ) : (
                      ''
                    )}
                    {i === 1 &&
                      `${
                        currentCountry?.currencySymbol
                      } ${electricityConverted.toFixed(2)}`}
                    {i === 2 &&
                      `${currentCountry?.carbonFactor} ${contents.carbonIntensityMetric.props.defaultMessage}`}
                    {i === 3 && 1.85}
                  </TableCell>
                  <TableCell>
                    <Tooltip direction="left">
                      <p>{el.tooltip}</p>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              );
            },
          )}
        </TableBody>
      </Table>
      <div className="footnote">
        <em>{contents.footnote}</em>
      </div>
    </div>
  );
};
export default AssumptionsTable;
